import React, { Component } from "react";
import "./SampleAadharPopup.scss";
import combineAadhar from "../../../assets/docSampleImages/combineAadharSample.jpg";
import borderLine from "../../../assets/Line 9.svg";
import AadharFront from "../../../assets/docSampleImages/Aadhar-Front-Sample.jpg";
import AadharBack from "../../../assets/docSampleImages/Aadhar-Back-Sample.jpg";
import { useDialogA11y } from "../../UI/Backdrop/Backdrop";
export interface IViewSampleAadharPopup {
  setShowPopup: Function;
  showPopup: boolean;
  text?: any;
  children?: any;
  parentClassName?: string;
  style?: any;
}
const SampleAadharPopup = (props: IViewSampleAadharPopup) => {
  const [readMore, setReadMore] = React.useState<boolean>(false);
  const closePopup = () => {
    if (props?.setShowPopup !== undefined) props.setShowPopup(false);
  };
  const dialogRef = useDialogA11y(!!props.showPopup, closePopup);
  const overlayRef = React.useRef<HTMLDivElement>(null);
  React.useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (overlayRef.current && event.target === overlayRef.current) {
        closePopup();
      }
    };

    const timer = setTimeout(() => {
      document.addEventListener("mousedown", handleClickOutside);
    }, 0);

    return () => {
      clearTimeout(timer);
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [props?.setShowPopup]);
  return (
    <div
      className={`overlay-Aadhar ${props?.parentClassName ?? ""}`}
      ref={overlayRef}
    >
      <div className="popup-Aadhar" role="dialog" aria-modal="true" aria-labelledby="sample-popup-title" ref={dialogRef}>
        {/* Close Button */}
        <button
          type="button"
          className="close-btn"
          aria-label="Close"
          onClick={closePopup}
        >
          <i className="edel-icon-close" aria-hidden="true" />
        </button>

        <h2 className="popup-title" id="sample-popup-title">Uploading Aadhaar Card Formats</h2>

        {/* Popup Content */}
        {/* {commonUIView()} */}
        <div className="Aadhar-format-1">
          <span>
            <span className="Aadhar-format-1-title">
              Uploading E-Aadhaar Card
            </span>
            {!readMore ? (
              <p className="Aadhar-format-read-more">
                Attach both sides of the E-Aadhaar as a PDF (Max Size: 2MB).{" "}
                <button
                  type="button"
                  className="read-more"
                  onClick={() => {
                    setReadMore(true);
                  }}
                >
                  Read more
                </button>
              </p>
            ) : (
              <p className="Aadhar-format-read-more">
                Attach both sides of the E-Aadhaar as a PDF (Max Size: 2MB).
                Download your E-Aadhaar Card from&nbsp;
                <a
                  className="link"
                  href="https://uidai.gov.in/en"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  uidai.gov.in/en/
                </a>
                &nbsp; website.
              </p>
            )}
          </span>
          <div className="imageSection">
            <img src={combineAadhar} alt="Sample Aadhaar card front and back" />
          </div>
        </div>

        <div className="aadhar-or-section">
          <img src={borderLine} className="img-section" width={140} alt="" aria-hidden="true" />
          <span className="title">OR</span>
          <img src={borderLine} className="img-section" width={140} alt="" aria-hidden="true" />
        </div>

        <div className="Aadhar-format-2">
          <span>
            <span className="Aadhar-format-1-title">
              Uploading physical Aadhaar Card
            </span>
            <p className="Aadhar-format-read-more">
              Attach front & back of your physical Aadhaar card in JPEG or PNG
              (Max Size: 2MB)
            </p>
            <span className="Aadhar-Front-row">
              <div className="image-container">
                <img
                  src={AadharFront}
                  width={130}
                  height={120}
                  className="aadhar-Front-sample document-image"
                 alt="Sample Aadhaar front" />
                <div className="badge">1</div>
              </div>

              <span className="Aadhar-Label">FRONT</span>
            </span>
            <span className="Aadhar-Front-row mt-20">
              <div className="image-container">
                <img
                  src={AadharBack}
                  width={130}
                  height={120}
                  className="aadhar-Front-sample document-image"
                 alt="Sample Aadhaar back" />
                <div className="badge">2</div>
              </div>

              <span className="Aadhar-Label">BACK</span>
            </span>
          </span>
        </div>
      </div>
    </div>
  );
};
export default SampleAadharPopup;
